module.exports = __webpack_public_path__ + "img/GERA_Ref1_1.png";